export default "__VITE_ASSET__B0gqd96V__"